import React, { useState, memo, useEffect } from "react";
import Select from "../../../../global/atoms/select/Select";
import { usePageType } from "../../../../../hooks/usePageType";
import { useAnalyticsContext } from "../../../../../config/GoogleTagManagerEvents";
import { VARIABLE_CONFIG } from "../../../../../constants/analyticsConstants/Variables";
import './sort.scss'
import { logError } from "../../../../global/utils/logger";

const getDropdownVals = [
    {
        label: 'Best Match',
        value: 'relevance'
    },
    {
        label: 'A-Z',
        value: 'sortAsc'
    },
    {
        label: 'Z-A',
        value: 'sortDesc'
    }
]

const SortOrder = (props) => {
    const { controller, relevanceSortCriterion, nameSortAsc, nameSortDesc } = props
    const [sortState, setSortState] = useState(controller.state)
    const [selVal, setSelVal] = useState(getDropdownVals[0].value)
    const pageType = usePageType();
    const { sendEventsForClick } = useAnalyticsContext();
    const onStateChange = () => {
        const state = controller.state;
        setSortState(state);
    };
    const sendEvents = val => {
        var eventLabel = '';
        getDropdownVals.map(matchval => {
            if (matchval.value === val) eventLabel = matchval.label;
        });
        try {
            sendEventsForClick(
                VARIABLE_CONFIG.EVENT.UAEVENT,
                VARIABLE_CONFIG.ECOMMERCE.UNDEFINED,
                `filter ${pageType}`,
                VARIABLE_CONFIG.EVENT_ACTION.SELECT,
                eventLabel
            );
        } catch (error) {
            logError(error,false,'sendEvents');
        }
    };
    useEffect(() => {
        controller.subscribe(onStateChange);
    }, []);

    const handleSort = (val) => {
        sendEvents(val);
        switch (val) {
            case 'relevance':
                controller.sortBy(relevanceSortCriterion)
                break
            case 'sortAsc':
                controller.sortBy(nameSortAsc)
                break
            case 'sortDesc':
                controller.sortBy(nameSortDesc)
                break
            default: break
        }
        setSelVal(val)
    }
    return (
        <Select
            className={'dropdown'}
            placeholder={selVal}
            dropDownValues={getDropdownVals}
            handleChange={handleSort}
            selectedValue={selVal}
           
        />
    )
};


export default memo(SortOrder)